// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Caml_obj = require("@rescript/std/lib/js/caml_obj.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Type_Teaser = require("../type/Type_Teaser.bs.js");

function toString(t) {
  switch (t) {
    case /* Anonymous */0 :
        return "Anonymous";
    case /* Connected */1 :
        return "Connected";
    case /* Disconnected */2 :
        return "Disconnected";
    
  }
}

var Status = {
  toString: toString
};

var t_encode = Spice.unitToJson;

var t_decode = Spice.unitFromJson;

function t_encode$1(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "progression",
                    true,
                    Spice.optionToJson(Type_Common.Progression.t_encode, v.progression)
                  ],
                  [
                    "favorite",
                    true,
                    Spice.optionToJson(Type_Teaser.Favorite.status_encode, v.favorite)
                  ]
                ]));
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var progression = Spice.optionFromJson(Type_Common.Progression.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "progression"), null));
  if (progression.TAG === /* Ok */0) {
    var favorite = Spice.optionFromJson(Type_Teaser.Favorite.status_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "favorite"), null));
    if (favorite.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                progression: progression._0,
                favorite: favorite._0
              }
            };
    }
    var e = favorite._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".favorite" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = progression._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".progression" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var DataMap = Type_String.$$Map.MakeMutable({
      Str: Type_String.Teaser.DsId,
      t_encode: t_encode$1,
      t_decode: t_decode$1
    });

var MagazineMap = Type_String.$$Map.Make({
      Str: Type_String.Teaser.DsId,
      t_encode: t_encode,
      t_decode: t_decode
    });

function magazines_encode(v) {
  return Curry._1(MagazineMap.t_encode, v);
}

function magazines_decode(v) {
  return Curry._1(MagazineMap.t_decode, v);
}

function anonymousFeatureStatus_encode(v) {
  if (v) {
    return ["Disabled"];
  } else {
    return ["Enabled"];
  }
}

function anonymousFeatureStatus_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Disabled" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Disabled */1
                  };
          }
      case "Enabled" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Enabled */0
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function fields_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "anonymousFeatureStatus",
                    false,
                    anonymousFeatureStatus_encode(v.anonymousFeatureStatus)
                  ],
                  [
                    "magazines",
                    false,
                    Spice.optionToJson(magazines_encode, v.magazines)
                  ],
                  [
                    "datas",
                    false,
                    Curry._1(DataMap.t_encode, v.datas)
                  ],
                  [
                    "token",
                    false,
                    Curry._1(Type_String.User.Token.t_encode, v.token)
                  ]
                ]));
}

function fields_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var anonymousFeatureStatus = anonymousFeatureStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "anonymousFeatureStatus"), null));
  if (anonymousFeatureStatus.TAG === /* Ok */0) {
    var magazines = Spice.optionFromJson(magazines_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "magazines"), null));
    if (magazines.TAG === /* Ok */0) {
      var datas = Curry._1(DataMap.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "datas"), null));
      if (datas.TAG === /* Ok */0) {
        var token = Curry._1(Type_String.User.Token.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "token"), null));
        if (token.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    anonymousFeatureStatus: anonymousFeatureStatus._0,
                    magazines: magazines._0,
                    datas: datas._0,
                    token: token._0
                  }
                };
        }
        var e = token._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".token" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = datas._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".datas" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = magazines._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".magazines" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = anonymousFeatureStatus._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".anonymousFeatureStatus" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode$2(v) {
  return Spice.optionToJson(fields_encode, v);
}

function t_decode$2(v) {
  return Spice.optionFromJson(fields_decode, v);
}

function addMagazine(magazineId, t) {
  if (t !== undefined && typeof t.token !== "number") {
    return {
            anonymousFeatureStatus: t.anonymousFeatureStatus,
            magazines: Caml_option.some(Curry._3(MagazineMap.set, Belt_Option.getWithDefault(t.magazines, Curry._1(MagazineMap.fromArray, [])), magazineId, undefined)),
            datas: t.datas,
            token: t.token
          };
  } else {
    return t;
  }
}

function removeMagazine(magazineId, t) {
  if (t !== undefined && typeof t.token !== "number") {
    return {
            anonymousFeatureStatus: t.anonymousFeatureStatus,
            magazines: Caml_option.some(Curry._2(MagazineMap.remove, Belt_Option.getWithDefault(t.magazines, Curry._1(MagazineMap.fromArray, [])), magazineId)),
            datas: t.datas,
            token: t.token
          };
  } else {
    return t;
  }
}

function hasMagazine(magazineId, t) {
  if (t === undefined) {
    return false;
  }
  var magazines = t.magazines;
  if (magazines !== undefined) {
    return Curry._2(MagazineMap.contains, Caml_option.valFromOption(magazines), magazineId);
  } else {
    return false;
  }
}

function getMagazines(t) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(t, (function (param) {
                        return param.magazines;
                      })), MagazineMap.keys), []);
}

function keepGreaterPosition(v1, v2) {
  if (v1 === undefined) {
    if (v2 !== undefined) {
      return v2;
    } else {
      return ;
    }
  }
  if (v2 === undefined) {
    return v1;
  }
  var progression1 = v1.progression;
  if (progression1 === undefined) {
    if (v2.progression !== undefined) {
      return v2;
    } else {
      return v1;
    }
  }
  var progression2 = v2.progression;
  if (progression2 !== undefined && !Type_Common.Progression.isGreater(Caml_option.valFromOption(progression1), Caml_option.valFromOption(progression2))) {
    return v2;
  } else {
    return v1;
  }
}

function merge(t1, t2) {
  var fn = function (param, v1, v2) {
    return keepGreaterPosition(v1, v2);
  };
  if (t1 !== undefined) {
    if (t2 !== undefined) {
      Curry._3(DataMap.merge, t1.datas, t2.datas, fn);
      return t2;
    } else {
      return t1;
    }
  } else if (t2 !== undefined) {
    return t2;
  } else {
    return ;
  }
}

function updateTeasers(teaser, dataMap) {
  var favStatus = teaser.favoriteStatus;
  var data_progression = Caml_option.some(teaser.progression);
  var data_favorite = favStatus ? favStatus._0 : /* NotFavorite */1;
  var data = {
    progression: data_progression,
    favorite: data_favorite
  };
  var newValue = Belt_Option.getWithDefault(keepGreaterPosition(Curry._2(DataMap.get, dataMap, teaser.dsId), data), data);
  Curry._3(DataMap.set, dataMap, teaser.dsId, newValue);
}

function addFavorite(teaser, t) {
  if (t !== undefined) {
    updateTeasers(teaser, t.datas);
    return t;
  } else {
    return t;
  }
}

function removeFavorite(dsId, t) {
  if (t === undefined) {
    return t;
  }
  var match = Curry._2(DataMap.get, t.datas, dsId);
  if (match !== undefined) {
    var match$1 = match.favorite;
    if (match$1 !== undefined && !match$1) {
      var newTeaser_progression = match.progression;
      var newTeaser_favorite = /* NotFavorite */1;
      var newTeaser = {
        progression: newTeaser_progression,
        favorite: newTeaser_favorite
      };
      Curry._3(DataMap.set, t.datas, dsId, newTeaser);
    }
    
  }
  return t;
}

function getFavorites(t) {
  if (t !== undefined) {
    return Curry._3(DataMap.reduce, t.datas, [], (function (acc, key, teaser) {
                  var match = teaser.favorite;
                  if (match !== undefined && !match) {
                    acc.push(key);
                  }
                  return acc;
                }));
  }
  
}

function getProgression(teasers, dsId) {
  var match = Curry._2(DataMap.get, teasers, dsId);
  if (match !== undefined) {
    return match.progression;
  }
  
}

function getProgressionById(t, id) {
  if (t !== undefined) {
    return getProgression(t.datas, id);
  }
  
}

function getTimeProgressionById(dsId, t) {
  if (t === undefined) {
    return ;
  }
  var match = Caml_option.valFromOption(t);
  if (match !== undefined) {
    return Belt_Option.flatMap(getProgression(match.datas, dsId), Type_Teaser.Helper.getTimeProgression);
  }
  
}

function updateProgressionInTeaser(programId, progression, teaserMap) {
  Curry._2(DataMap.get, teaserMap, programId);
  var __x_progression = Caml_option.some(progression);
  var __x = {
    progression: __x_progression
  };
  Curry._3(DataMap.set, teaserMap, programId, __x);
}

function setTimeProgression(dsId, progression, t) {
  if (t === undefined) {
    return t;
  }
  var fields = Caml_option.valFromOption(t);
  if (fields !== undefined) {
    updateProgressionInTeaser(dsId, progression, fields.datas);
    return t;
  } else {
    return t;
  }
}

function make(magazines, favoritesOpt, progressionsOpt, token) {
  var favorites = favoritesOpt !== undefined ? favoritesOpt : [];
  var progressions = progressionsOpt !== undefined ? progressionsOpt : [];
  var datas = Curry._1(DataMap.make, undefined);
  Belt_Array.forEach(favorites, (function (dsId) {
          Curry._3(DataMap.set, datas, dsId, {
                favorite: /* Favorite */0
              });
        }));
  Belt_Array.forEach(progressions, (function (param) {
          var id = param.id;
          var progressionSsoData_progression = Caml_option.some(param.progression);
          var progressionSsoData = {
            progression: progressionSsoData_progression
          };
          var teaser = Curry._2(DataMap.get, datas, id);
          if (teaser === undefined) {
            return Curry._3(DataMap.set, datas, id, progressionSsoData);
          }
          var favorite = teaser.favorite;
          if (favorite === undefined) {
            return Curry._3(DataMap.set, datas, id, progressionSsoData);
          }
          var newrecord = Caml_obj.obj_dup(progressionSsoData);
          Curry._3(DataMap.set, datas, id, (newrecord.favorite = favorite, newrecord));
        }));
  return {
          anonymousFeatureStatus: /* Enabled */0,
          magazines: Belt_Option.map(magazines, (function (magazines) {
                  return Curry._1(MagazineMap.fromArray, Belt_Array.map(magazines, (function (key) {
                                    return [
                                            key,
                                            undefined
                                          ];
                                  })));
                })),
          datas: datas,
          token: token
        };
}

var disconnected = make(undefined, undefined, undefined, Type_String.User.Token.disconnected);

var emptyAnonymousUser = make(undefined, undefined, undefined, Type_String.User.Token.anonymous);

function getUserStatus(t) {
  if (t === undefined) {
    return /* Disconnected */2;
  }
  var tmp = t.token;
  if (typeof tmp === "number") {
    return /* Disconnected */2;
  } else if (tmp.TAG === /* Anonymous */0) {
    return /* Anonymous */0;
  } else {
    return /* Connected */1;
  }
}

function getAnonymousFeatureStatus(user) {
  return Belt_Option.mapWithDefault(user, /* Enabled */0, (function (param) {
                return param.anonymousFeatureStatus;
              }));
}

function updateAnonymousFeatureStatus(t, status) {
  if (t !== undefined) {
    return {
            anonymousFeatureStatus: status,
            magazines: t.magazines,
            datas: t.datas,
            token: t.token
          };
  } else {
    return t;
  }
}

function getVideoById(id, t) {
  if (t !== undefined) {
    return Belt_Option.mapWithDefault(Curry._2(DataMap.get, t.datas, id), /* NotFavorite */1, (function (teaser) {
                  var favorite = teaser.favorite;
                  if (favorite !== undefined) {
                    return favorite;
                  } else {
                    return /* NotFavorite */1;
                  }
                }));
  } else {
    return /* NotFavorite */1;
  }
}

function getToken(t) {
  return Belt_Option.map(t, (function (param) {
                return param.token;
              }));
}

function getProgressionAndFavorite(param) {
  var teaser = param[1];
  var progression = Belt_Option.getWithDefault(teaser.progression, Type_Common.Progression.noProgression);
  var favoriteStatus = Belt_Option.getWithDefault(teaser.favorite, /* NotFavorite */1);
  return {
          dsId: param[0],
          progression: progression,
          favoriteStatus: favoriteStatus
        };
}

function getAllProgressionsAndFavoriteStatus(t) {
  return Belt_Option.map(t, (function (param) {
                return Belt_Array.map(Curry._1(DataMap.toArray, param.datas), getProgressionAndFavorite);
              }));
}

exports.Status = Status;
exports.t_encode = t_encode$2;
exports.t_decode = t_decode$2;
exports.getFavorites = getFavorites;
exports.getProgressionById = getProgressionById;
exports.getTimeProgressionById = getTimeProgressionById;
exports.setTimeProgression = setTimeProgression;
exports.getVideoById = getVideoById;
exports.addMagazine = addMagazine;
exports.removeMagazine = removeMagazine;
exports.hasMagazine = hasMagazine;
exports.getMagazines = getMagazines;
exports.addFavorite = addFavorite;
exports.removeFavorite = removeFavorite;
exports.getUserStatus = getUserStatus;
exports.emptyAnonymousUser = emptyAnonymousUser;
exports.make = make;
exports.merge = merge;
exports.disconnected = disconnected;
exports.getToken = getToken;
exports.getAllProgressionsAndFavoriteStatus = getAllProgressionsAndFavoriteStatus;
exports.getAnonymousFeatureStatus = getAnonymousFeatureStatus;
exports.updateAnonymousFeatureStatus = updateAnonymousFeatureStatus;
/* DataMap Not a pure module */
